import { useMutation } from 'react-query';
import { API_ENDPOINTS } from '../utils/api-endpoints';
import http from '../utils/http';

export const useSearchQuery = () => {
  return useMutation((queryValue: String) =>
    http.get(`${API_ENDPOINTS.SEARCH}/index?query=${queryValue}`)
  );
};
